// Global Instructions Rule Applied!
//
// Configuration → Pipelines detail row (view__pipeline_stages_admin): one
// pipeline_config row joined to its library stage, with per-stage settings, the
// days-in-stage thresholds, and a live deal count. passthrough() for resilience.
import { z } from 'zod'
import { validateWithZodSchema } from '../../core/utils/utilities.ts'

export const PipelineStageAdminSchema = z
  .object({
    pipeline_config__id: z.string(),
    pipeline_config__pipeline: z.string().nullish(),
    pipeline_config__stage: z.string().nullish(),
    pipeline_stages__id: z.string().nullish(),
    pipeline_stages__name: z.string().nullish(),
    pipeline_stages__colour: z.string().nullish(),
    pipeline_config__colour: z.string().nullish(),
    pipeline_config__default: z.boolean().nullish(),
    pipeline_config__sequence_kb: z.number().nullish(),
    pipeline_config__sequence_tbl: z.number().nullish(),
    pipeline_config__visible_kb: z.boolean().nullish(),
    pipeline_config__visible_tbl: z.boolean().nullish(),
    pipeline_config__drop_option_kb: z.boolean().nullish(),
    pipeline_config__drop_option_tbl: z.boolean().nullish(),
    pipeline_config__max_age_kb: z.number().nullish(),
    pipeline_config__max_age_tbl: z.number().nullish(),
    pipeline_config__stage_warn_days: z.number().nullish(),
    pipeline_config__stage_warn_colour: z.string().nullish(),
    pipeline_config__stage_crit_days: z.number().nullish(),
    pipeline_config__stage_crit_colour: z.string().nullish(),
    pipeline_config__show_age_counters: z.boolean().nullish(),
    pipeline_config__deal_count: z.number().nullish()
  })
  .passthrough()

export type PipelineStageAdminModel = z.infer<typeof PipelineStageAdminSchema>

export function validatePipelineStageAdmin(data: unknown): PipelineStageAdminModel {
  return validateWithZodSchema(PipelineStageAdminSchema, data, 'pipeline stage admin') as PipelineStageAdminModel
}
